import {SystemVI} from "./system/vi";
import {HRMVI} from "./hrm/vi";
import {AdvanceVI} from "./advance/vi";
import {CRMVI} from "./crm/vi";
import {SettingVI} from "./setting/vi";
import {OkrVI} from "./setting/okr/vi";
import {evaluationKpiVI} from "./hrm/evaluation/vi";

export const LayoutVI = {
    "layout": {
        "profile": "Trang cá nhân",
        "system": "Hệ thống",
        "statementInfo": "Thông tin đối soát",
        "userManual": "Hướng dẫn sử dụng",
        "theme": "Đổi màu giao diện",
        "language": "Ngôn ngữ",
        "changePassword": "Đổi mật khẩu",
        "changeEmail": "Đổi email",
        "vi": "Tiếng Việt",
        "en": "English",
        "setting": "Cài đặt",
        "logout": "Đăng xuất",
        "report": "Báo cáo",
        "contract": "Hợp đồng",
        "addWorkNormal": "Công việc thường",
        "applicationSetting" : "Đơn từ",
        "applicationAction" : "Tạo cho chính mình",
        ...SystemVI,
        ...HRMVI,
        ...AdvanceVI,
        ...CRMVI,
        ...SettingVI,
        ...OkrVI,
        ...evaluationKpiVI,
    }


}
